"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAccountInfo = exports.fetchQueueStatus = void 0;
var constants_1 = require("./constants");
var utils_1 = require("./utils");
/**
 * Returns a promise that, when awaited, fetches the queue status for the given queue.
 */
var fetchQueueStatus = function (_a) {
    var _b = _a.queue, queue = _b === void 0 ? 'YS_Chat_Support' : _b, environment = _a.environment;
    return __awaiter(void 0, void 0, void 0, function () {
        var queueId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    queueId = constants_1.chatQueueMapping[queue];
                    if (!queueId)
                        return [2 /*return*/, 'closed'];
                    return [4 /*yield*/, fetch("".concat(getAccountSwissApiBase(environment), "/agent/availability/queue/").concat(queueId, "?mediaType=Chat&direction=Inbound"))
                            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, res.json()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); })
                            .then(function (res) { return (0, utils_1.getQueueStatus)(res); })
                            .catch(function () { return 'kinda-busy'; })];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
};
exports.fetchQueueStatus = fetchQueueStatus;
// some helper fetchers below here, should not be exported from the library
var fetchAccountInfo = function (environment) { return __awaiter(void 0, void 0, void 0, function () {
    var match, accessToken, apiUrl, response, accountNumbers, uniqueAccountNumbers, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                match = document.cookie.match(new RegExp('(^| )' + 'access_token' + '=([^;]+)'));
                accessToken = match != null ? match[2] : null;
                if (!accessToken) {
                    return [2 /*return*/, null];
                }
                apiUrl = getAccountApiBase(environment);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(apiUrl, "/cv-communication/isLoggedIn"), {
                        headers: { 'x-sentry-sts-token': accessToken },
                    }).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!res.ok) {
                                        throw new Error('Not logged in');
                                    }
                                    return [4 /*yield*/, res.json()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
            case 2:
                _a.sent();
                return [4 /*yield*/, fetch("".concat(apiUrl, "/cv-communication/getAccounts"), {
                        headers: { 'x-sentry-sts-token': accessToken },
                    }).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!res.ok) {
                                        throw new Error('Not logged in');
                                    }
                                    return [4 /*yield*/, res.json()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
            case 3:
                response = (_a.sent()).response;
                accountNumbers = response.map(function (account) { return account.accountNo; });
                uniqueAccountNumbers = accountNumbers.reduce(function (array, item) {
                    if (array.indexOf(item) < 0)
                        array.push(item);
                    return array;
                }, []);
                return [2 /*return*/, uniqueAccountNumbers.join(',')];
            case 4:
                e_1 = _a.sent();
                // do nothing
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.fetchAccountInfo = fetchAccountInfo;
var getAccountApiBase = function (environment) {
    return environment === 'production'
        ? 'https://prod-a.digital-help.prod.managed-eks.aws.nuuday.nu/ghapi/kundeservice'
        : 'https://test-a.digital-help.non-prod.managed-eks.aws.nuuday.nu/ghapi/kundeservice';
};
var getAccountSwissApiBase = function (environment) {
    return environment === 'production' ? 'https://api.swiss.nuuazure.dk' : 'https://test.api.swiss.np-nuuazure.dk';
};
//# sourceMappingURL=api.js.map